import React, { useState } from 'react'
import { Icon, Tag } from 'antd'

import {
  formatCount,
  formatPlanValue,
  getStoryboardPlanCount,
  getStoryboardPlanRationale,
  getStoryboardPlanShots
} from '../../utils'
import './StoryboardPlanPreview.scss'

const StoryboardPlanPreview = ({
  plan,
  committedPanels,
  planApproved,
  showAll = false,
  previewLimit = 4,
  showMoreControl = true
}) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const shots = getStoryboardPlanShots(plan)
  const count = getStoryboardPlanCount(plan)
  const rationale = getStoryboardPlanRationale(plan)
  const shouldShowAllShots = showAll || (showMoreControl && isExpanded)
  const visibleShots = shouldShowAllShots
    ? shots
    : shots.slice(0, previewLimit)

  if (!plan) return null

  return (
    <div className="creative-direction-chat__storyboard-plan">
      <div className="creative-direction-chat__storyboard-plan-header">
        <div>
          <span>Shot plan</span>
          <strong>
            {formatCount(committedPanels || count)} planned{' '}
            {formatCount(committedPanels || count) === 1 ? 'shot' : 'shots'}
          </strong>
        </div>
        <Tag color={planApproved ? 'green' : 'blue'}>
          {planApproved ? 'Approved' : 'Review'}
        </Tag>
      </div>

      {rationale ? (
        <p className="creative-direction-chat__storyboard-rationale">
          {rationale}
        </p>
      ) : null}

      {shots.length ? (
        <div className="creative-direction-chat__storyboard-shot-list">
          {visibleShots.map((shot, index) => {
            const shotNumber =
              shot.panel_number || shot.panelNumber || index + 1
            const title =
              shot.beat ||
              shot.title ||
              shot.name ||
              shot.summary ||
              `Shot ${shotNumber}`
            const summary =
              shot.summary && shot.summary !== title ? shot.summary : ''
            const meta = [
              formatPlanValue(shot.shot_type || shot.shotType),
              formatPlanValue(shot.camera_angle || shot.cameraAngle),
              formatPlanValue(shot.camera_movement || shot.cameraMovement),
              formatPlanValue(shot.location_key || shot.locationKey),
              formatPlanValue(shot.character_keys || shot.characterKeys),
              formatPlanValue(shot.outfit_keys || shot.outfitKeys)
            ].filter(Boolean)

            return (
              <div
                className="creative-direction-chat__storyboard-shot"
                key={`${shotNumber}-${index}`}
              >
                <span>{shotNumber}</span>
                <div>
                  <strong>{title}</strong>
                  {summary ? <p>{summary}</p> : null}
                  {meta.length ? <small>{meta.join(' - ')}</small> : null}
                </div>
              </div>
            )
          })}
          {showMoreControl && !showAll && shots.length > visibleShots.length ? (
            <button
              type="button"
              className="creative-direction-chat__storyboard-show-more"
              onClick={() => setIsExpanded(true)}
            >
              View full plan
              <Icon type="down" />
            </button>
          ) : null}
          {showMoreControl && !showAll && isExpanded && shots.length > previewLimit ? (
            <button
              type="button"
              className="creative-direction-chat__storyboard-show-more"
              onClick={() => setIsExpanded(false)}
            >
              Show less
              <Icon type="up" />
            </button>
          ) : null}
        </div>
      ) : (
        <div className="creative-direction-chat__quiet-note">
          <Icon type="info-circle" />
          <span>The plan was created, but no shot rows were returned.</span>
        </div>
      )}
    </div>
  )
}

export default StoryboardPlanPreview
